<template>
    <div>
<!--        <iframe :src="url" width="100%" style="height: 700px"></iframe>-->
    </div>
</template>

<script>
    export default {
        name: "Wp_jd_course",
        data(){
            return{
                url: "https://xt.17weike.com/Column/LiveRoom?StudioID=TjYwNzc5ODE1NjEy&source=friend"
                // url: "https://xt.17weike.com/Column/ColumnPage"
            }
        },
        created() {
            window.location.href=this.url;
        }
    }
</script>

<style scoped>

</style>